import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Link, LinkProps } from 'react-router-dom';
import SelectableBulletedItem, { SelectableBulletedItemProps } from './SelectableBulletedItem';

interface Props extends SelectableBulletedItemProps {
  to: LinkProps['to'];
}

const LinkSelectableBulletedItem: FC<Props> = ({ to, ...innerProps }) => {
  return (
    <StyledLink to={to}>
      <SelectableBulletedItem {...innerProps} />
    </StyledLink>
  );
};

export default LinkSelectableBulletedItem;

const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: none;

  &:visited,
  &:hover,
  &:active {
    color: inherit;
    text-decoration: none;
  }
`;
